import { css, Global } from '@emotion/react';
import { FC } from 'react';

export interface ToastContainerSyleProps {
	style?: Record<string, string>;
}

export const ToastContainerSyle: FC<ToastContainerSyleProps> = ({ style = {} }) => {
	return (
		<Global
			styles={css`
				#chakra-toast-manager-top-right {
					${Object.entries(style)
						.map(([key, value]) => `${key}: ${value};`)
						.join('\n')}
				}
			`}
		/>
	);
};
